import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, logComponentLoad } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import ViewLargeCustomers from './ViewLargeCustomers'
import LargeProjectsNav from './LargeProjectsNav';



class EnterLargeCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerName: '',
            phone1: '',
            contactPerson1: '',
            loading: false,
            algoliaUser: ''
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }



            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "EnterLargeCustomer");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    sendCustomer = () => {
        console.log("++++++++:sendCustomer");
        console.log(this.state.customerName)
        console.log(this.state.phone1)
        console.log(this.state.contactPerson1)

        if (this.state.customerName == '') {
            alert("No cusotmer Name")
        } else if (this.state.phone1 == '') {
            alert("No Customer Phone")
        } else if (this.state.phone1.length != 10) {
            alert("No Phone number be 10 digits")
        } else if (this.state.contactPerson1 == '') {
            alert("No Constact Person")
        } else {
            console.log("sending data..");

            this.setState({ loading: true })

            axios.post(pythonApiIp + 'addNewLargeCustomer', {
                apiKey: "PrintB@da7",
                customerName: this.state.customerName,
                phone1: this.state.phone1,
                contactPerson1: this.state.contactPerson1,
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding customer");

                        alert(response.data.message);
                    } else {
                        console.log("FAILED");
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("sales")
            ? <div>
                <LargeProjectsNav />

                <h1>ENTER LARGE PROJECT CUSTOMER</h1>


                <Form size='large' onSubmit={this.sendCustomer}>
                    <Segment stacked>
                        <label>Enter Customer Name</label>
                        <Form.Input
                            fluid
                            icon='blind'
                            iconPosition='left'
                            placeholder='Customer Name'
                            type='text'
                            name="customerName"
                            value={this.state.customerName}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Customer Phone</label>
                        <Form.Input
                            fluid
                            icon='phone'
                            iconPosition='left'
                            placeholder='Customer Phone 1'
                            type='number'
                            name="phone1"
                            value={this.state.phone1}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Customer Contact</label>
                        <Form.Input
                            fluid
                            icon='play'
                            iconPosition='left'
                            placeholder='Customer contactPerson1'
                            type='test'
                            name="contactPerson1"
                            value={this.state.contactPerson1}
                            onChange={this.handleTextInputChange}
                        />
                        <Button>SEND</Button>
                    </Segment>

                </Form>
                <ViewLargeCustomers />
            </div>
            : <h4>loading error a75</h4>

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                {wholeUI}


            </div>
        );
    }
}

export default EnterLargeCustomer;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/EnterLargeCustomer.js